import { Button } from "@/components/ui/button";
import { ReactNode, useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogContent,
} from "@/components/ui/dialog";
import { CreateFeeForm } from "./create-fee-form";

interface CreateFeeButtonProps {
  trigger?: ReactNode;
}

export function CreateFeeButton({ trigger }: CreateFeeButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="default" title="Create New Fee">
            Create Fee
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Create New Fee</DialogTitle>
        </DialogHeader>
        <CreateFeeForm onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
